import tasksIcon from 'assets/images/icons/tasks.svg';
import formGreyIcon from 'assets/images/icons/form-grey.svg';
import dataSourceIcon from 'assets/images/icons/data-source.svg';
import labelIcon from 'assets/images/icons/label.svg';
import circleHollowIcon from 'assets/images/icons/circle-hollow.svg';
import infoCircleIcon from 'assets/images/icons/info-circle.svg';
import userGreyIcon from 'assets/images/icons/user-grey.svg';
import clockPlusIcon from 'assets/images/icons/clock-plus.svg';
import locationGreyIcon from 'assets/images/icons/location-grey.svg';
import calendarPlusIcon from 'assets/images/icons/calendar-plus.svg';
import calendarGreyIcon from 'assets/images/icons/calendar-grey.svg';

export const labelColors = [
  '#3863A7',
  '#745ABB',
  '#8DBF55',
  '#8DBF55',
  '#629B71',
  '#F7D150',
  '#DD7534',
  '#B84431',
  '#7D4931',
  '#8D8D8D',
];

export const schedulesSortOptions = [
  { value: 'createdAt', displayValue: 'select_creation_date' },
  { value: 'endDate', displayValue: 'select_due_date' },
  { value: 'updatedAt', displayValue: 'select_last_updated' },
];

export const tasksTabsList = [
  {
    id: 1,
    title: 'tabs_scheduled',
    value: 'scheduled_task',
    breadcrumbValue: { icon: tasksIcon, items: ['sidebar_tasks', 'tabs_scheduled'] },
  },
  {
    id: 2,
    title: 'tabs_active',
    value: 'active_task',
    breadcrumbValue: { icon: tasksIcon, items: ['sidebar_tasks', 'tabs_active'] },
  },
  {
    id: 3,
    title: 'tabs_archived_schedule',
    value: 'archived_schedule',
    breadcrumbValue: { icon: tasksIcon, items: ['sidebar_tasks', 'tabs_archived_schedule'] },
  },
  {
    id: 4,
    title: 'tabs_archived_task',
    value: 'archived_task',
    breadcrumbValue: { icon: tasksIcon, items: ['sidebar_tasks', 'tabs_archived_task'] },
  },
];

export const activeTasksHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'TK-ID',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'displayRefNumber',
  },
  {
    name: 'name',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'title',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'description',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'company_field',
    displayName: 'table_header_company_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'companyFieldValue',
    icon: dataSourceIcon,
  },
  {
    name: 'labels',
    displayName: 'table_header_label',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'labels',
    icon: labelIcon,
    populateFunc: 'populateTaskLabels',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'priority',
    icon: circleHollowIcon,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'status',
    icon: infoCircleIcon,
    populateFunc: 'populateTaskStatus',
  },
  {
    name: 'assignedTo',
    displayName: 'table_header_assigned_to',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: userGreyIcon,
    populateFunc: 'populateTaskAssignment',
    callbackFunc: 'openChangeAssigneeCallback',
  },
  {
    name: 'start_date',
    displayName: 'table_header_start_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'startDate',
    icon: calendarPlusIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'due_date',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: calendarGreyIcon,
    populateFunc: 'populateTaskDueDateTime',
  },
  {
    name: 'completed_by',
    displayName: 'table_header_completed_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'completedBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'completion_date',
    displayName: 'table_header_completion_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'completionDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'started_by',
    displayName: 'table_header_started_by',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'startedBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'review_due_date',
    displayName: 'table_header_review_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'supervisorReviewDueDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'reviewed_at',
    displayName: 'table_header_reviewed_at',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'supervisorReviewedDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'review_by',
    displayName: 'table_header_reviewed_by',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'supervisorReviewedBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'location',
    displayName: 'table_header_location',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'location',
    icon: locationGreyIcon,
  },
  {
    name: 'created_by',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'createdBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'created_at',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'createdAt',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'task_detail',
    displayName: '',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateTaskSubmissionReportViewIcon',
    callbackFunc: 'openTaskDetailDrawer',
  },
  {
    name: 'submission_list',
    displayName: '',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateRelevantListModalOpenIcon',
    callbackFunc: 'openTaskSubmissionsCallback',
  },
];

export const scheduleTasksHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'TK-ID',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'displayRefNumber',
  },
  {
    name: 'name',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'title',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'description',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'company_field',
    displayName: 'table_header_company_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'companyFieldValue',
    icon: dataSourceIcon,
  },
  {
    name: 'labels',
    displayName: 'table_header_label',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'labels',
    icon: labelIcon,
    populateFunc: 'populateTaskLabels',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'priority',
    icon: circleHollowIcon,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'status',
    icon: infoCircleIcon,
    populateFunc: 'populateTaskStatus',
  },
  {
    name: 'assignedTo',
    displayName: 'table_header_assigned_to',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: userGreyIcon,
    populateFunc: 'populateTaskAssignment',
    callbackFunc: 'openChangeAssigneeCallback',
  },
  {
    name: 'start_date',
    displayName: 'table_header_start_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'startDate',
    icon: calendarPlusIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'due_date',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'endDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'completed_by',
    displayName: 'table_header_completed_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'completedBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'completion_date',
    displayName: 'table_header_completion_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'completionDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'review_due_date',
    displayName: 'table_header_review_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'supervisorReviewDueDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'location',
    displayName: 'table_header_location',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'location',
    icon: locationGreyIcon,
  },
  {
    name: 'created_by',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'createdBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'created_at',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'createdAt',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
];

export const archivedTasksHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'TK-ID',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'displayRefNumber',
  },
  {
    name: 'name',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'title',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'description',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'company_field',
    displayName: 'table_header_company_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'companyFieldName',
    icon: dataSourceIcon,
  },
  {
    name: 'labels',
    displayName: 'table_header_label',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'labels',
    icon: labelIcon,
    populateFunc: 'populateTaskLabels',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'priority',
    icon: circleHollowIcon,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'status',
    icon: infoCircleIcon,
    populateFunc: 'populateTaskStatus',
  },
  {
    name: 'start_date',
    displayName: 'table_header_start_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'startDate',
    icon: calendarPlusIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'due_date',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'endDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'completed_by',
    displayName: 'table_header_completed_by',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'completedBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'completion_date',
    displayName: 'table_header_completion_date',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'completionDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'review_due_date',
    displayName: 'table_header_review_due_date',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'reviewDueDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'location',
    displayName: 'table_header_location',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'location',
    icon: locationGreyIcon,
  },
  {
    name: 'created_by',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'createdBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'created_at',
    displayName: 'table_header_created_at',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'createdAt',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
];

export const newScheduleTabList = [
  { value: 'tabs_basic', displayValue: 'tabs_basic' },
  { value: 'tabs_advance', displayValue: 'tabs_advance' },
];

export const timeUnitOptionsList = [
  { value: 'minutes', displayValue: 'select_minutes' },
  { value: 'hours', displayValue: 'select_hours' },
  { value: 'days', displayValue: 'select_days' },
];

export const recurrenceTypeOptionsList = [
  { value: 'daily', displayValue: 'select_daily' },
  { value: 'weekly', displayValue: 'select_weekly' },
  { value: 'monthly', displayValue: 'select_monthly' },
];

export const recurrenceIntervalOptions = [
  { value: 1, displayValue: '1' },
  { value: 2, displayValue: '2' },
  { value: 3, displayValue: '3' },
];

export const repeatsOnOptionsList = Array.from({ length: 31 }, (_, i) => ({
  value: i + 1,
  displayValue: String(i + 1),
}));

export const schedulesHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'ST-ID',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'displayRefNumber',
  },
  {
    name: 'name',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateScheduleTitle',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'description',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'company_field',
    displayName: 'table_header_company_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'companyFieldValue',
    icon: dataSourceIcon,
  },
  {
    name: 'label',
    displayName: 'table_header_label',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'labels',
    icon: labelIcon,
    populateFunc: 'populateTaskLabels',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'priority',
    icon: circleHollowIcon,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'period',
    displayName: 'table_header_period',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: clockPlusIcon,
    translateVal: true,
    populateFunc: 'populateSchedulePeriod',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'status',
    icon: infoCircleIcon,
    populateFunc: 'populateScheduleStatus',
  },
  {
    name: 'assignedTo',
    displayName: 'table_header_assigned_to',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: userGreyIcon,
    populateFunc: 'populateScheduleAssignment',
    callbackFunc: 'openChangeAssigneeCallback',
  },
  {
    name: 'start_date',
    displayName: 'table_header_start_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'startDate',
    icon: calendarPlusIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'due_date',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'endDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'created_by',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'createdBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
  {
    name: 'task_list',
    displayName: '',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateRelevantListModalOpenIcon',
    callbackFunc: 'openScheduleTaskCallback',
  },
];

export const archivedSchedulesHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'ST-ID',
    mandatory: true,
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'displayRefNumber',
  },
  {
    name: 'name',
    displayName: 'table_header_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateScheduleTitle',
  },
  {
    name: 'description',
    displayName: 'table_header_description',
    type: 'string',
    isRequired: false,
    isSelected: false,
    associatedKey: 'description',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'company_field',
    displayName: 'table_header_company_field',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'companyFieldName',
    icon: dataSourceIcon,
  },
  {
    name: 'label',
    displayName: 'table_header_label',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'labels',
    icon: labelIcon,
    populateFunc: 'populateTaskLabels',
  },
  {
    name: 'priority',
    displayName: 'table_header_priority',
    type: 'string',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'priority',
    icon: circleHollowIcon,
    populateFunc: 'populatePriorityLabelWithIcon',
  },
  {
    name: 'period',
    displayName: 'table_header_period',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: clockPlusIcon,
    translateVal: true,
    populateFunc: 'populateSchedulePeriod',
  },
  {
    name: 'status',
    displayName: 'table_header_status',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'status',
    icon: infoCircleIcon,
    populateFunc: 'populateScheduleStatus',
  },
  {
    name: 'start_date',
    displayName: 'table_header_start_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'startDate',
    icon: calendarPlusIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'due_date',
    displayName: 'table_header_due_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'endDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'created_by',
    displayName: 'table_header_created_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'createdBy',
    icon: userGreyIcon,
    populateFunc: 'populatePublishedByName',
  },
];

export const taskSubmissionHeaderList = [
  {
    name: 'referenceNumber',
    displayName: 'Ref no',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'referenceNumber',
  },
  {
    name: 'completed_by',
    displayName: 'table_header_completed_by',
    type: 'string',
    isRequired: false,
    isSelected: true,
    icon: userGreyIcon,
    populateFunc: 'databaseUpdatedBy',
  },
  {
    name: 'form_title',
    displayName: 'table_header_form_name',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'formTitle',
    icon: formGreyIcon,
  },
  {
    name: 'form_status',
    displayName: 'table_header_form_status',
    type: 'text',
    isRequired: false,
    isSelected: true,
    translateVal: true,
    associatedKey: 'submissionFlowState',
    icon: infoCircleIcon,
    populateFunc: 'populateSubmissionFlowState',
  },
  {
    name: 'completion_date',
    displayName: 'table_header_completion_date',
    type: 'string',
    isRequired: false,
    isSelected: true,
    associatedKey: 'completeDate',
    icon: calendarGreyIcon,
    populateFunc: 'populateDateTime',
  },
  {
    name: 'submission_report',
    displayName: '',
    type: 'string',
    isRequired: false,
    isSelected: true,
    populateFunc: 'populateTaskSubmissionReportViewIcon',
    callbackFunc: 'openSubmissionReportModal',
  },
];

// export const reminderTypeOptionsList = [
//   { value: 'before_start', displayValue: 'Before - start' },
//   { value: 'before_due', displayValue: 'Before - due' },
//   { value: 'after_start', displayValue: 'After - start' },
//   { value: 'after_due', displayValue: 'After - due' },
//   { value: 'completion_date', displayValue: 'Completion date' },
// ];

export const scheduleStatusFilterOptions = [
  { value: 'published', displayValue: 'select_open' },
  { value: 'draft', displayValue: 'select_draft' },
  { value: 'closed', displayValue: 'select_closed' },
];

export const scheduleDueDateFilterOptions = [
  { value: 'all', displayValue: 'select_all' },
  { value: 'today', displayValue: 'select_today' },
  { value: 'next_seven_days', displayValue: 'select_7_days' },
  { value: 'next_thirty_days', displayValue: 'select_30_days' },
  { value: 'custom', displayValue: 'select_custom' },
];

export const taskStatusFilterOptions = [
  { value: 'todo', displayValue: 'select_to_do' },
  { value: 'in_progress', displayValue: 'select_in_progress' },
  { value: 'completed', displayValue: 'select_completed' },
  { value: 're_opened', displayValue: 'select_re_opened' },
  { value: 'closed', displayValue: 'select_closed' },
];

export const taskDueDateFilterOptions = [
  { value: 'all', displayValue: 'select_all' },
  { value: 'today', displayValue: 'select_today' },
  { value: 'next_seven_days', displayValue: 'select_7_days' },
  { value: 'next_thirty_days', displayValue: 'select_30_days' },
  { value: 'custom', displayValue: 'select_custom' },
];

export const taskCompletionDateFilterOptions = [
  { value: 'all', displayValue: 'select_all' },
  { value: 'today', displayValue: 'select_today' },
  { value: 'last_seven_days', displayValue: 'select_last_seven_days' },
  { value: 'last_thirty_days', displayValue: 'select_last_thirty_days' },
  { value: 'custom', displayValue: 'select_custom' },
];

export const getAssignmentDisplayValue = (users = [], groups = []) => {
  const displayItems = [];
  let remainingCount = 0;

  // Add first group
  if (groups.length > 0 && groups[0].groupName) {
    displayItems.push(groups[0].groupName);
  }

  // Add first user
  if (users.length > 0 && (users[0].firstName || users[0].lastName)) {
    displayItems.push(`${users[0].firstName} ${users[0].lastName}`);
  }

  // Ensure minimum 2 items
  if (displayItems.length < 2) {
    if (groups.length > 1 && groups[1].groupName && !displayItems.includes(groups[1].groupName)) {
      displayItems.push(groups[1].groupName);
    } else if (users.length > 1 && (users[1].firstName || users[1].lastName)) {
      const name = `${users[1].firstName} ${users[1].lastName}`;
      if (!displayItems.includes(name)) {
        displayItems.push(name);
      }
    }
  }

  // Count remaining
  groups.forEach((g) => {
    if (g.groupName && !displayItems.includes(g.groupName)) remainingCount++;
  });

  users.forEach((u) => {
    const name = `${u.firstName} ${u.lastName}`;
    if (name && !displayItems.includes(name)) remainingCount++;
  });

  let result = displayItems.join(', ');
  if (remainingCount > 0) result += ` +${remainingCount}`;

  return result;
};

export const getUserGroupDisplayValue = (users = [], groups = []) => {
  const displayItems = [];
  let remainingCount = 0;
  // Step 1: Add first group if exists
  if (groups.length > 0 && groups[0].name) {
    displayItems.push(groups[0].name);
  }
  // Step 2: Add first user if exists
  if (users.length > 0 && users[0].name) {
    displayItems.push(users[0].name);
  }
  // Step 3: Ensure minimum 2 items
  if (displayItems.length < 2) {
    if (groups.length > 1 && groups[1].name && !displayItems.includes(groups[1].name)) {
      displayItems.push(groups[1].name);
    } else if (users.length > 1 && users[1].name && !displayItems.includes(users[1].name)) {
      displayItems.push(users[1].name);
    }
  }
  // Step 4: Count remaining items in single loop
  remainingCount = 0;
  for (let i = 0; i < groups.length; i++) {
    if (!displayItems.includes(groups[i].name)) remainingCount++;
  }
  for (let i = 0; i < users.length; i++) {
    if (!displayItems.includes(users[i].name)) remainingCount++;
  }
  // Step 5: Build final string
  let result = displayItems.join(', ');
  if (remainingCount > 0) result += ` +${remainingCount}`;

  return result;
};
